import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPage.css';

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="static-page">
      <div className="static-page-header">
        <h2>このサイトについて</h2>
        <button className="back-button" onClick={() => navigate('/')}>
          ← 戻る
        </button>
      </div>
      <div className="static-page-content">

        <h3>「Sail Alert URAGA」について</h3>
        <p>
          浦賀水道を航行する船舶の入航予定を収集し、現在や過去の情報を参照、検索することができるサイトです。
        </p>

        <h3>浦賀水道について</h3>
        <p>
          浦賀水道とは、東京湾の入り口であり、房総半島と三浦半島に挟まれた狭い海峡です。<br />
          東京湾と相模湾を結ぶ重要な航路であり、多くの船舶が行き来しています。<br />
          この航路を航行する船舶のうち、一定以上の大きさを持つものは、入航予定を公開することが義務付けられています。
        </p>

        <h3>注意</h3>
        <p>
          当サイトは船舶をウォッチングする人のためのデータ公開を目的としています。<br />
          船舶の入航予定は様々な要因で変更されることがあり、必ずしも実際の航行と一致するとは限りません。<br />
          <strong>本サイトの情報を実際の船舶の航行に利用しないでください。</strong>
        </p>
        <ul>
          <li>入航予定は海上保安庁・東京湾海上交通センターが公開する航行情報から作成しています。</li>
          <li>航行情報は海上保安庁のサイトに負荷をかけないよう、時間を置いて取得しています。</li>
          <li>取得元で削除された入航予定についても一定時間内は表示しています。</li>
          <li>表示される入航予定が実際の船舶の航行と一致するとは限りません。</li>
          <li>本サイトは非公式であり、海上保安庁など関係各機関とは一切関係がありません。</li>
          <li>本サイトの内容について海上保安庁など関係各機関に問い合わせることはおやめください。</li>
        </ul>

        <h3>このサイトの使い方</h3>
        <p>
          トップページでは、今日の入航予定を一覧で見ることができます。<br />
          デフォルトでは北航船・南航船を合わせた全ての入航予定が表示されます。<br />
          北航船・南航船のタブで絞り込むことができます。<br />
          前日・翌日のボタンで日付を切り替えることができます。<br />
          中央の日付が書かれたボタンでトップページに戻ります。
        </p>
        <p>
          日付検索では、特定の日付の入航予定を検索することができます。<br />
          現在、過去の任意の日付で検索できますが、表示されるのはデータが取得されている日付の入航予定のみです。<br />
          船舶検索では、特定の船舶の入航予定を検索することができます。<br />
          船舶の名称、国籍、船種、全長、トン数で検索できます。
        </p>
        <p>
          右上の「Googleでログイン」ボタンで既にアカウントがある場合はログイン、ない場合は新規登録ができます。<br />
          ログインによるカスタマイズ機能を現在開発中です。
        </p>

        <h3>表示される情報の見方</h3>
        <ul>
          <li>左上のアイコンは船種を表しています。</li>
          <li>旗国は船舶の国籍を表しています。</li>
          <li>入港(北航船の場合)は目的地の港、出港(南航船の場合)は出発地の港です。</li>
          <li>「中ノ瀬」は中ノ瀬航路を通航予定の船舶です。</li>
          <li>「水先人」は水先人乗船予定の船舶です。</li>
          <li>「巨大船」は全長200m以上の船舶です。</li>
        </ul>

        <h3>ステータス</h3>
        <ul>
          <li>新規: 前回の更新で新しく追加された入航予定</li>
          <li>有効: 変更がない入航予定</li>
          <li>変更あり: 前回の更新から内容が変更された入航予定</li>
          <li>進行中: 現在既に入航していると思われる入航予定</li>
          <li>削除済み: 前回の更新から削除された入航予定</li>
        </ul>

        <h3>作者について</h3>
        <p>
          <a href="https://nysalor.larus.jp/" target="_blank" rel="noopener noreferrer">プロフィール</a>
        </p>
        <p>
          当サイトの情報は
          <a href="https://x.com/nysalor" target="_blank" rel="noopener noreferrer">X (Twitter)</a>
          および
          <a href="https://bsky.app/profile/nysalor.bsky.social" target="_blank" rel="noopener noreferrer">Bluesky</a>
          でも発信しています。
        </p>

        <p className="last-updated">最終更新: 2026年6月</p>
      </div>
    </div>
  );
};

export default About;
